module.exports = __webpack_public_path__ + "static/media/food-truck-corporate-background.422afbb6.jpg";